import React from "react";
import { useNavigate } from "react-router-dom";

// Components
import { AqmarineButton, BlackButton, OrangeButton } from "./Buttons";

export default function GameCard({ game }) {
  const navigate = useNavigate();

  return (
    <div className=" flex items-end h-[400px] lg:h-[400px] xl:h-[480px] relative">
      <div className="absolute top-0 left-0 right-0 mx-auto h-[32%] lg:h-[32%] xl:h-[38%] w-[75%] lg:w-[75%] xl:w-[80%]">
        {game.coming_soon ? (
          <img
            src={require(`../assets/core/img/comingsoon.png`)}
            alt=""
            className="block h-full mx-auto"
          />
        ) : (
          <img
            src={require(`../assets/core/img/${game.game_id}.png`)}
            alt=""
            className="block h-full mx-auto"
          />
        )}
      </div>

      <div className="border-2 border-black bg-retro-grey w-full h-[90%]">
        <div className="h-[32%] lg:h-[32%] xl:h-[38%]"></div>

        <div className="w-[80%] h-[25%] mb-5 mx-auto">
          <p className="uppercase font-retro-rounded font-medium text-center text-[160%]">
            {game.game_name}
          </p>
        </div>

        {game.coming_soon ? (
          <div className="py-[10px] w-[80%] mx-auto mb-5">
            <div className="">
              <BlackButton size="large" disabled={true}>
                Coming Soon
              </BlackButton>
            </div>
          </div>
        ) : (
          <div className="w-[80%] mx-auto mb-5">
            <div className="mb-5">
              <AqmarineButton
                onClick={() => {
                  navigate(`/g/${game.game_id}`, {
                    state: { game },
                  });
                }}
              >
                Play
              </AqmarineButton>
            </div>

            <div className="">
              <OrangeButton
                onClick={() => {
                  navigate(`/g/${game.game_id}`, {
                    state: { game },
                  });
                }}
              >
                Level
              </OrangeButton>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
